// extracted by mini-css-extract-plugin
export default {"tooltip":"Jo-z","sharingV2":"Ko-z","sharingIconsV2":"Lo-z","links":"Mo-z","link":"No-z","facebookV2":"Oo-z","twitterV2":"Po-z","pinterestV2":"Qo-z"};